<template>
  <div class="login-outer">
    <!-- <Header></Header> -->
    <div class="login-inner">
      <div class="login-left"><img src="/center@2x.png" /></div>
      <div class="login-right">
        <img
          class="logo"
          v-if="
            $store.state.common.bureau &&
            $store.state.common.bureau.schoolShowType == '1'
          "
          src="/logo.png"
        />
        <img
          class="logo"
          v-if="
            $store.state.common.bureau &&
            $store.state.common.bureau.schoolShowType == '2'
          "
          :src="
            $store.state.common.bureau &&
            $store.state.common.bureau.schoolLogoUrl
          "
        />
        <div class="desc">
          <p>{{ bureauName }}</p>  
          中心校管理系统
        </div>
        <a-form class="login-form" @submit="handleSubmit" :form="form" v-if="bureauId">
          <!-- 账号输入 -->
          <template v-if="loginType == '1'">
            <a-form-item class="margin-right-0">
              <a-input
                type="text"
                placeholder="请输入手机"
                class="login-input-text"
                v-decorator="[
                  'mobile',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^1[3456789]\d{9}$/,
                        message: '请输入正确的手机号',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="mobile"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>

            <!-- 验证码 -->
            <a-form-item class="margin-0">
              <a-col class="gutter-row" :span="16">
                <a-form-item class="margin-right-10">
                  <a-input
                    size="large"
                    type="text"
                    placeholder="验证码"
                    v-decorator="[
                      'smscode',
                      {
                        rules: [
                          {
                            required: true,
                            pattern: /^\d{6}$/,
                            message: '请输入6位的验证码',
                          },
                        ],
                        validateTrigger: 'blur',
                      },
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="mail"
                      :style="{ color: 'rgba(0,0,0,.25)' }"
                    />
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col class="gutter-row" :span="8">
                <a-button
                  class="getCaptcha"
                  tabindex="-1"
                  :disabled="state.smsSendBtn"
                  @click.stop.prevent="getCaptcha"
                  v-text="
                    (!state.smsSendBtn && '获取验证码') || state.time + ' s'
                  "
                ></a-button>
              </a-col>
            </a-form-item>
          </template>

          <template v-else>
            <!-- 用户名或密码 -->
            <a-form-item class="margin-right-0">
              <a-input
                type="text"
                placeholder="请输入用户名/手机"
                class="login-input-text"
                v-decorator="[
                  'mobile',
                  [{ required: true, message: '请输入用户名或者手机号' }],
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>

            <!-- 密码 -->
            <a-form-item class="margin-right-0">
              <a-input
                type="password"
                placeholder="请输入密码"
                class="login-input-text"
                v-decorator="[
                  'password',
                  { rules: [{ required: true, message: '请输入密码' }] },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>
          </template>

          <!-- 切换另一种登录方式 -->
          <div class="login-type-but">
            <span v-if="loginType == '1'" @click="loginType = '2'"
              >密码登录</span
            >
            <span v-else @click="loginType = '1'">验证码登录</span>
          </div>

          <!-- 确定登录 -->
          <a-form-item
            class="margin-right-0"
            style="margin-top: 16px; margin-bottom: 10px"
          >
            <a-button
              size="large"
              type="primary"
              htmlType="submit"
              class="login-button"
              >登录</a-button
            >
          </a-form-item>
        </a-form>

        <div class="mistake-prompt" v-else>
            <div>当前域名未开通业务，<br></div> 
            <div>请检查并联系业务支持：<br></div>
           <div class="domain-name">{{ domainName }}</div> 
          </div>
      </div>
    </div>
    <center-school-modal
      ref="centerSchool"
      :schoolList="schoolList"
    ></center-school-modal>
  </div>
</template>
<script>
import user from '../../api/user'

import institution from '../../api/institution'

import Header from '../../components/Header'

import CenterSchoolModal from './CenterSchoolModal.vue'

import bureau from '../../api/bureau'
import Vue from 'vue'
export default {
  name: 'CenterManageLogin',
  components: {
    Header,
    CenterSchoolModal,
  },
  data() {
    return {
      mobile: '',
      password: '',
      bureauId:-11111111,
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false,
      },
      form: this.$form.createForm(this),
      loginType: '2', //1验证码登录，2密码登录
      schoolList: [],
      domainName:location.host,
      bureauName:'',
    }
  },

  methods: {
     initObtain(){
     const res =  bureau.getBureauId().then((res)=>{
      if(res){
          this.bureauId = res
        }
     }).finally(()=>{
      if(this.bureauId == -11111111){
        this.bureauId = null
      }
     })
      
   console.log(res,this.bureauId,'then报错的信息是什么')
   console.log(this.bureauId,'这里面的值是什么1')
    },
    getCaptcha(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
      } = this

      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          user
            .getSmscode({
              mobile: values.mobile,
              mode: 'center_manage',
            })
            .then((res) => {
              setTimeout(hide, 2500)
            })
            .catch((err) => {
              console.error('错误信息：', err)
              setTimeout(hide, 1)
              clearInterval(interval)
              state.time = 60
              state.smsSendBtn = false
            })
        }
      })
    },

    //登录
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        console.log(values)
        // return
        console.log(this.loginType)
        values.mobile = values.mobile.trim()
        console.log(' values.mobile', values.mobile)
        let requestFun =
          this.loginType == '1' ? user.centerSmsLogin : user.centerLogin
        // return
        requestFun(values).then((res) => {
          console.log(res)

          this.getSchoolList()

          //情况缓存
          // this.$store.commit('CLEARLOGIN');
          // this.handleRouter();
          // //储存user信息
          // this.$ls.set('token', res.accessToken.accessToken);
          // this.$ls.set('refreshToken', res.accessToken.refreshToken);
          // this.$store.dispatch('getInit').then(res => {
          // 	console.log('获取的码表信息是：', res);
          // 	//处理路由
          // 	this.judgeEnter();
          // });
        })
      })
    },
    getSchoolList() {
      let requestFun = user.getSchoolList
      requestFun().then((res) => {
        console.log(res)
        this.schoolList = res.data == 'NON' ? [] : res.data
        this.$refs.centerSchool.init()
      })
    },
    //处理路由
    handleRouter() {
      //点击菜单页权限页面给清除掉
      let routerList = this.$router.options.routes
      window.menuList = []
      if (routerList[0] && routerList[0].children) {
        routerList[0].children = []
      }
      //删除404页面 重新在获取权限的地方在添加路由
      routerList.map((item, index) => {
        if (item.path == '*') {
          routerList.splice(index, 1)
        }
      })
      this.$router.selfaddRoutes(routerList)
    },

    //判断入口
    judgeEnter() {
      this.$store.dispatch('getUserInfo').then((res) => {
        //如果是课程方
        if (res.accRole.id == 4) {
          institution.getInstitutionByUser().then((institutionInfo) => {
            console.log(institutionInfo)
            if (institutionInfo.data.status == 3) {
              this.$router.push('courseList')
            } else {
              this.$router.push('institutionRegister')
            }
          })
        } else {
          this.$router.push('termSynopsis')
        }
      })
    },
  },
  mounted(){
    this.initObtain()
  },
  created() {
    bureau.getBureau().then(res=>{
      console.log(res,'getBureau');
      this.bureauName = res.bureauName
    })
    //清空缓存
    this.$store.commit('CLEARLOGIN')
    this.$ls.clear('bureauId')
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.login-outer {
  background: #ebf2ff;
  height: 100vh;
  margin: 0px auto;
  text-align: center;
  .login-inner {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    > div {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
.login-left {
  img {
    width: 754px;
    height: auto;
    margin: 0 70px 0 0;
  }
}
.login-right {
  border-radius: 8px;
  margin: 0px auto;
  width: 400px;
  text-align: center;
  background: white;
  padding: 44px 36px 24px;
  .logo {
    width: 72px;
    height: auto;
  }
  .desc {
    margin-top: 10px;
    color: #151617;
    font-size: 18px;
    font-weight: 600;
  }
}
.login-form {
  margin-top: 30px;
  width: 100%;
}
.login-input-text {
  height: 40px;
}
.login-button {
  width: 100%;
}

.getCaptcha {
  display: block;
  width: 100%;
  height: 40px;
}

.login-type-but {
  text-align: left;
  color: $primary-color-dark;
  padding-left: 2px;
  cursor: pointer;
}
.institution-register {
  cursor: pointer;
  text-align: right;
  color: $normal-color-dark;
  font-size: 14px;
}
.mistake-prompt{
  // display: flex;
  // justify-content: center;
  width: 328px;
  text-align: center;
  margin: 20px auto 82px auto;
  color: #000;
  font-size: 20px;
  font-weight: 300;
  border: 1px solid rgb(201, 201, 202);
  padding: 30px 10px;
  box-sizing: border-box;
  border-radius: 15px;
  .domain-name{
    font-weight: 500;
  }
}
</style>
